(function (angular) {
  "use strict";

  angular.module('myApp').component('contactUs', {
    templateUrl: '/contactUs/contactUs.tpl.html',
    controller: [
      '$scope', '$http', 'aimSave','contactUsService',
      function ($scope, $http, aimSave, contactUsService) {

        $scope.aim = new aimSave();
        $scope.aim.serviceMethod = contactUsService.save;
        $scope.aim.dto.country = "US";

        function formatState(state) {
          if (!state.id) {
            return state.text;
          }
          var baseUrl = "https://hatscripts.github.io/circle-flags/flags/";
          var $state = $(
            '<span><img src="' + baseUrl + '/' + state.element.value.toLowerCase() + '.svg" class="img-flag" /> ' + state.text + '</span>'
          );
          $state.find("span").text(state.text);
          $state.find("img").attr("src", baseUrl + "/" + state.element.value.toLowerCase() + ".svg");

          return $state;
        };

        // Select 2 Script
        setTimeout(function () {
          $(".custom-selectbox").select2({
            minimumResultsForSearch: -1
          });

          $("#countries").select2({
            templateSelection: formatState,
            templateResult: formatState
          });
        }, 200);

      }
    ],
  });

}(window.angular));
